"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentJsonMapper = exports.ComponentDynamoMapper = void 0;
var component_dynamodb_1 = require("./component-dynamodb");
Object.defineProperty(exports, "ComponentDynamoMapper", { enumerable: true, get: function () { return component_dynamodb_1.ComponentDynamoMapper; } });
var component_json_1 = require("./component-json");
Object.defineProperty(exports, "ComponentJsonMapper", { enumerable: true, get: function () { return component_json_1.ComponentJsonMapper; } });
